import { getDefaultSidebarWidth } from './defaultSidebarWidth';

/**
 * ONE remembered width shared by the four DJ sidebars (Rekordbox / Serato /
 * Traktor / VirtualDJ). They're the same panel in different skins and only
 * one shows at a time, so a resize in any of them is the user sizing "the DJ
 * panel" — remembered across restarts, falling back to the viewport-aware
 * default. Written on drag end (see the sidebars' resize handlers), read at
 * slice-init.
 */
const KEY = 'djSidebar.width';
export const DJ_SIDEBAR_MIN_WIDTH = 280;
export const DJ_SIDEBAR_MAX_WIDTH = 500;

export function getPersistedDjSidebarWidth() {
    try {
        const w = parseInt(localStorage.getItem(KEY), 10);
        if (Number.isFinite(w)) {
            return Math.min(DJ_SIDEBAR_MAX_WIDTH, Math.max(DJ_SIDEBAR_MIN_WIDTH, w));
        }
    } catch { /* ignore */ }
    return getDefaultSidebarWidth();
}

export function persistDjSidebarWidth(width) {
    try { localStorage.setItem(KEY, String(Math.round(width))); } catch { /* ignore */ }
}

/** The main playlist sidebar is its own panel (different min-width, can
 *  coexist with the rail) — remembered separately from the DJ panel. */
const PLAYLIST_KEY = 'playlistSidebar.width';
export const PLAYLIST_SIDEBAR_MIN_WIDTH = 200;
export const PLAYLIST_SIDEBAR_MAX_WIDTH = 500;

export function getPersistedPlaylistSidebarWidth() {
    try {
        const w = parseInt(localStorage.getItem(PLAYLIST_KEY), 10);
        if (Number.isFinite(w)) {
            return Math.min(PLAYLIST_SIDEBAR_MAX_WIDTH, Math.max(PLAYLIST_SIDEBAR_MIN_WIDTH, w));
        }
    } catch { /* ignore */ }
    return getDefaultSidebarWidth();
}

export function persistPlaylistSidebarWidth(width) {
    try { localStorage.setItem(PLAYLIST_KEY, String(Math.round(width))); } catch { /* ignore */ }
}
